import { render, staticRenderFns } from "./ActivateLabelButton.vue?vue&type=template&id=00c681a3&"
import script from "./ActivateLabelButton.vue?vue&type=script&lang=js&"
export * from "./ActivateLabelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports